import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "",
};

const idSlice = createSlice({
  name: "id",
  initialState,
  reducers: {
    accoutHandler: (state, action) => {
      state.id = action.payload;
    },
  },
});

export default idSlice.reducer;
export const { accoutHandler } = idSlice.actions;
